import { Field, FieldGroup } from "@/components/ui/field"
import { Skeleton } from "@/components/ui/skeleton"

export type FormSkeletonField = "input" | "textarea"

type FormSkeletonProps = {
    fields: Array<FormSkeletonField>
}

/** Label + field-height bars for a form content area. No fake input chrome. */
export function FormSkeleton({ fields }: FormSkeletonProps) {
    return (
        <FieldGroup>
            {fields.map((kind, index) => (
                <Field key={`${kind}-${index}`}>
                    <Skeleton className="h-4 w-24" />
                    <Skeleton className={kind === "textarea" ? "h-24 w-full" : "h-9 w-full"} />
                </Field>
            ))}
        </FieldGroup>
    )
}
